module.exports = __webpack_public_path__ + "static/media/Vector 2.996f63f8.png";